import styled from 'styled-components'
import { rem } from 'polished'
import BasicCalendar, { CalendarDayGrid } from 'components/Common/Calendar/BasicCalendar'
import {
  SEARCH_DATE_PICKER_DAY_HEIGHT_PX,
  SEARCH_DATE_PICKER_DAY_ROW_GAP_PX,
} from './SearchDatePickerDay'

/*
 * BasicCalendar laying out SearchDatePickerDay cells. The grid owns the row
 * height and the gap between week rows, so overlays drawn over the day grid
 * (e.g. CalendarRangeGlowOverlay) inherit the same geometry instead of
 * re-encoding it in px.
 *
 * The block-start margin keeps the weekday header the same distance from the
 * first week row as the cells' former margin-top provided.
 */
const SearchDatePickerCalendar = styled(BasicCalendar)`
  ${CalendarDayGrid} {
    margin-block-start: ${rem(SEARCH_DATE_PICKER_DAY_ROW_GAP_PX)};
    grid-auto-rows: ${rem(SEARCH_DATE_PICKER_DAY_HEIGHT_PX)};
    row-gap: ${rem(SEARCH_DATE_PICKER_DAY_ROW_GAP_PX)};

    &.fixed-height {
      grid-template-rows: repeat(6, ${rem(SEARCH_DATE_PICKER_DAY_HEIGHT_PX)});
    }
  }
`

export default SearchDatePickerCalendar
